import type { AssignedAgentsQueryData } from "web_myplann/Api/Advisor/Types/AssignedAgentsQueryData";

export const setMainAdvisorInCache = (
	cached: AssignedAgentsQueryData | undefined,
	id: number,
) =>
	cached
		? {
				...cached,
				data: cached.data.map((advisor) => ({
					...advisor,
					isMain: advisor.id === id,
				})),
			}
		: undefined;
